type Observer<Payload> = (event: Payload) => void
export const observableResource = <EventTypes extends { [event: string]: { data: unknown } }>(
  events: (keyof EventTypes)[]
) => {
  const observers = events.reduce(
    (acc, event) => ({ ...acc, [event]: [] }),
    {} as {
      [Event in keyof EventTypes]: Observer<EventTypes[Event]['data']>[]
    }
  )

  return {
    subscribe<Event extends keyof EventTypes>(
      event: Event,
      observer: Observer<EventTypes[Event]['data']>
    ) {
      observers[event].push(observer)
      return () => {
        const index = observers[event].indexOf(observer)
        if (index !== -1) {
          observers[event].splice(index, 1)
        }
      }
    },
    publish<Event extends keyof EventTypes>(event: Event, eventData: EventTypes[Event]['data']) {
      observers[event].forEach(observer => observer(eventData))
    },
  }
}

export type PublishCallback<EventTypes extends { [event: string]: { data: unknown } }> = <
  Event extends keyof EventTypes,
>(
  event: Event,
  eventData: EventTypes[Event]['data']
) => void

export type SubscribeCallback<EventTypes extends { [event: string]: { data: unknown } }> = <
  Event extends keyof EventTypes,
>(
  event: Event,
  observer: Observer<EventTypes[Event]['data']>
) => () => void
